import { NgModule } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  RouterModule,
  Routes,
} from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LogInTargetComponent } from './components/log-in-target/log-in-target.component';
import { LogOutComponent } from './components/log-out/log-out.component';
import { CallbackComponent } from './components/callback/callback.component';
import { redirectIfUnauthenticated } from './guards/auth.helper';
import { ErrorComponent } from './components/error/error.component';

const authGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
  redirectIfUnauthenticated(state);

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'callback',
    component: CallbackComponent,
    title: 'Callback',
  },
  {
    path: 'error',
    component: ErrorComponent,
    title: 'Error',
  },
  {
    path: 'log-out',
    component: LogOutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Log Out',
  },
  {
    path: 'logged-in',
    component: LogInTargetComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Logged In',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('@cp/dashboard/compliance-portal-feature-dashboard.module').then(
        (m) => m.CompliancePortalFeatureDashboardModule,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  {
    path: 'compliance',
    loadChildren: () =>
      import('@cp/compliance/compliance-portal-feature-compliance.module').then(
        (m) => m.CompliancePortalFeatureComplianceModule,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Compliance',
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('@cp/profile/compliance-portal-feature-profile.module').then(
        (m) => m.CompliancePortalFeatureProfileModule,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Profile',
  },
  {
    path: 'revalidation',
    loadChildren: () =>
      import(
        '@cp/revalidation/compliance-portal-feature-revalidation.module'
      ).then((m) => m.CompliancePortalFeatureRevalidationModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Revalidation',
  },
  {
    path: 'resources',
    loadChildren: () =>
      import('@cp/resources/compliance-portal-feature-resources.module').then(
        (m) => m.CompliancePortalFeatureResourcesModule,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Resources',
  },
  {
    path: 'training',
    loadChildren: () =>
      import('@cp/training/compliance-portal-feature-training.module').then(
        (m) => m.CompliancePortalFeatureTrainingModule,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Training',
  },
  {
    path: 'help-and-support',
    loadChildren: () =>
      import(
        '@cp/help-and-support/compliance-portal-feature-help-and-support.module'
      ).then((m) => m.CompliancePortalFeatureHelpAndSupportModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    title: 'Help and support',
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    title: 'Page Not Found',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
